import classNames from 'classnames';
import * as React from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {SpringValue} from 'react-spring';

import styles from './ExportCsv.less';
import {TranslateUtils} from 'src/js/common/utils';

const I18N = defineMessages({
  EXPORT_DATA: {
    id: 'common.export.title',
    defaultMessage: 'Export data (.csv)',
    description: 'title text for export data button',
  },
});

interface OwnProps {
  csvString: string;
  fileName: string;
  handleAnimatedButtonClick?: () => void;
  transformScaleValue?: SpringValue<number>;
}

type Props = OwnProps;

export const ExportCsv: React.FC<Props> = (props) => {
  const {csvString, fileName, handleAnimatedButtonClick, transformScaleValue} =
    props;

  const intl = useIntl();

  const handleClick = () => {
    if (handleAnimatedButtonClick) {
      handleAnimatedButtonClick();
    }
  };

  return (
    <a
      className={classNames({
        [styles.dlExportCsv]: true,
        'float-end': true,
      })}
      download={fileName}
      href={`data:text/csv;charset=utf-8,${encodeURI(csvString)}`}
      style={{
        transform: transformScaleValue
          ? transformScaleValue.to((val) => `scale(${val * val})`)
          : '1',
      }}
      title={TranslateUtils.translate(I18N.EXPORT_DATA, intl)}
      onClick={handleClick}
      data-name='exportCsv'
    >
      <i className={'far fa-file-alt fa-2x'} />
    </a>
  );
};

ExportCsv.displayName = 'ExportCsv';
